import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SlideadjustmentunitpriceInfo } from 'sg-api';
import { FormGroupDirective, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SearchStat } from '../../../../../sg-kc-shared/constants/searchStat';

/**
 * スライド調整単価登録画面(承認情報)
 * @exports
 * @class Sgkc032dSlideTankaApprovalInfoComponent
 * @implements {OnInit, OnDestroy}
 */
@Component({
    selector: 'app-sgkc032d-slide-tanka-approval-info',
    templateUrl: './sgkc032d-slide-tanka-approval-info.component.html',
    styleUrl: './sgkc032d-slide-tanka-approval-info.component.scss'
})
export class Sgkc032dSlideTankaApprovalInfoComponent implements OnInit, OnDestroy {
    /** 単価表登録管理情報 */
    @Input() slideadjustmentunitpriceInfo: SlideadjustmentunitpriceInfo;
    /** 画面モード */
    @Input() mode: string;

    /** ステータス */
    apprvStsAname = this.fb.control({ value: '', disabled: true });
    /** 登録部署 */
    regDepartmentname = this.fb.control({ value: '', disabled: true });
    /** 登録者 */
    registrantname = this.fb.control({ value: '', disabled: true });
    /** 登録日時 */
    regDateTime = this.fb.control({ value: '', disabled: true });
    /** 承認部署 */
    apprvDepartmentname = this.fb.control({ value: '', disabled: true });
    /** 承認者 */
    approvername = this.fb.control({ value: '', disabled: true });
    /** 承認日時 */
    apprvDateTime = this.fb.control({ value: '', disabled: true });
    /** 単価表承認情報保持Form */
    slideAdjustmentUnitpriceInfoForm: UntypedFormGroup = this.fb.group({
        apprvStsAname: this.apprvStsAname,
        regDepartmentname: this.regDepartmentname,
        registrantname: this.registrantname,
        regDateTime: this.regDateTime,
        apprvDepartmentname: this.apprvDepartmentname,
        approvername: this.approvername,
        apprvDateTime: this.apprvDateTime,
    })
    /** 親コンポーネント保持領域 */
    parentForm: UntypedFormGroup;

    /**
     * コンストラクタ
     * @param {FormGroupDirective} parent 親コンポーネントのFormGroupDirective
     * @param {UntypedFormBuilder} fb フォームビルダー
     * @memberof Sgkc032dSlideTankaApprovalInfoComponent
     */
    constructor(
        private parent: FormGroupDirective,
        private fb: UntypedFormBuilder,) {
    }

    /** 
    * 初期処理
    * @memberof Sgkc032dSlideTankaApprovalInfoComponent
    */
    ngOnInit(): void {
        // 登録日時のフォーマット
        // YYYYMMdd形式の日付を分解
        const regDateFormat = this.convertDateFormat(this.slideadjustmentunitpriceInfo.regDate);
        const regTimeFormat = this.convertTimeFormat(this.slideadjustmentunitpriceInfo.registrationtime);
        // フォーマットを作成
        const regTimeDateFormat = `${regDateFormat} ${regTimeFormat}`;

        let apprvTimeDateFormat = null;
        // 承認ステータスがが承認済の場合フォーマット
        if(this.slideadjustmentunitpriceInfo.apprvStatuscode ===  SearchStat.SHONINZUMI){

        // 承認日時のフォーマット
        const apprvDateFormat = this.convertDateFormat(this.slideadjustmentunitpriceInfo.apprvDate);
        const apprvTimeFormat = this.convertTimeFormat(this.slideadjustmentunitpriceInfo.apprvHms);
        // フォーマットを作成
        apprvTimeDateFormat = `${apprvDateFormat} ${apprvTimeFormat}`;
        }

        this.parentForm = this.parent.form;
        this.parentForm.addControl('slideAdjustmentUnitpriceInfoForm', this.slideAdjustmentUnitpriceInfoForm);
        // 単価表登録管理情報FormGroupに初期値を設定
        this.slideAdjustmentUnitpriceInfoForm.controls['apprvStsAname'].setValue(this.slideadjustmentunitpriceInfo.apprvStsAname);
        this.slideAdjustmentUnitpriceInfoForm.controls['regDepartmentname'].setValue(this.slideadjustmentunitpriceInfo.regDepartmentname);
        this.slideAdjustmentUnitpriceInfoForm.controls['registrantname'].setValue(this.slideadjustmentunitpriceInfo.registrantname);
        this.slideAdjustmentUnitpriceInfoForm.controls['regDateTime'].setValue(regTimeDateFormat);
        this.slideAdjustmentUnitpriceInfoForm.controls['apprvDepartmentname'].setValue(this.slideadjustmentunitpriceInfo.apprvDepartmentname);
        this.slideAdjustmentUnitpriceInfoForm.controls['approvername'].setValue(this.slideadjustmentunitpriceInfo.approvername);
        this.slideAdjustmentUnitpriceInfoForm.controls['apprvDateTime'].setValue(apprvTimeDateFormat);
    }

    /**
     * コンポーネント破棄時の処理
     * @memberof Sgkc032dSlideTankaApprovalInfoComponent
     */
    ngOnDestroy(): void {
        this.parentForm.clearValidators();
        this.parentForm.updateValueAndValidity();
        this.parentForm.removeControl('slideAdjustmentUnitpriceInfoForm');
    }

    /**
     * 日付のフォーマット変換
     * @param {string} dateStr YYYYMMDD形式の日付文字列
     * @returns {string} YYYY/mm/DD形式の日時文字列
     * @memberof Sgkc032dSlideTankaApprovalInfoComponent
     */
    convertDateFormat(dateStr: string): string {
        // YYYYMMDD形式の文字列を受け取る
        const year = dateStr.slice(0, 4);
        const month = dateStr.slice(4, 6);
        const day = dateStr.slice(6, 8);
        // YYYY/mm/DD形式に変換して返す
        return `${year}/${month}/${day}`;
    }

    /**
     * 時間のフォーマット変換
     * @param {string} timeStr HHmmss形式の時間文字列
     * @returns {string} HH:mm:ss形式の時間文字列
     * @memberof Sgkc032dSlideTankaApprovalInfoComponent
     */
    convertTimeFormat(timeStr: string): string {
        // HHmmss形式の文字列を受け取る
        const HH = timeStr.slice(0, 2);
        const mm = timeStr.slice(2, 4);
        const ss = timeStr.slice(4, 6);
        // HH:mm:ss形式に変換して返す
        return `${HH}:${mm}:${ss}`;
    }
}